import React from 'react';
import {Button, Input} from "semantic-ui-react";

const GridHeader = ({name, width, input, loading, downloadExcel, canDownloadWaybills, downloadWaybills, canCreate, history, btn, searchQuery, onSearchChange, onSearchClear, title = null}) => {
    return (
        <section className={`header-block`} style={{width: width && width + 'px'}}>
            <div className='name-block'>
                <h1 title={title || name}>
                    {name}
                </h1>
                {/* Поле глобального поиска */}
                {onSearchChange && (
                    <div style={{ marginTop: '10px', maxWidth: '400px' }}>
                        <Input
                            placeholder="Поиск по всем полям..."
                            value={searchQuery || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                onSearchChange(value);
                            }}
                            action={{
                                icon: searchQuery ? 'close' : 'search',
                                onClick: searchQuery ? onSearchClear : null,
                                disabled: !searchQuery
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                )}
                {input && input}
            </div>

            <div className="buttons-block">
                {downloadWaybills && <Button
                    className='btn_border_blue'
                    onClick={() => downloadWaybills()}
                    disabled={loading || !canDownloadWaybills}
                >
                    Скачать накладные
                </Button>}
                {downloadExcel && <Button
                    className='btn_border_blue'
                    onClick={() => downloadExcel()}
                    disabled={loading}
                >
                    Выгрузка в Excel
                </Button>}
                {history && canCreate && <Button
                    className='btn_light-blue btn_icon_plus'
                    onClick={() => history.push('/parcels/new')}
                >
                    Создать отправление
                </Button>}
                {btn && btn}
            </div>
        </section>
    );
};

export default GridHeader;


// WEBPACK FOOTER //
// ./App/components/GridHeader.jsx